import React from 'react';

const formatTime = (date) => {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(dateObj.getTime())) return '';
  return dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
};

const getLogLevelColor = (level) => {
  switch(level) {
    case 'error': return 'text-semantic-error';
    case 'warning': return 'text-semantic-warning';
    case 'success': return 'text-semantic-success';
    case 'command': return 'text-accent-purple';
    default: return 'text-semantic-info';
  }
};

const LogsView = ({ logs, logRef }) => {
  return (
    <div className="logs-view h-full overflow-y-auto overflow-x-hidden custom-scrollbar" ref={logRef}>
      <div className="p-3 font-mono text-xs text-ui-text-primary">
        {logs.map((log, index) => {
          if (!log || !log.content) return null;
          return (
            <div key={index} className="mb-1 break-words">
              <span className="text-ui-text-tertiary">[{formatTime(log.timestamp)}]</span>{' '}
              <span className={getLogLevelColor(log.level)}>[{log.level.toUpperCase()}]</span>{' '}
              <span className="whitespace-pre-wrap">{log.content}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LogsView; 